'use client';

import { useEffect } from 'react';

export function KeyboardModality() {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        document.documentElement.classList.add('using-keyboard');
      }
    };

    const onPointerDown = () => {
      document.documentElement.classList.remove('using-keyboard');
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('pointerdown', onPointerDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('pointerdown', onPointerDown);
    };
  }, []);

  return null;
}
